import { useSyncExternalStore } from "react";
import { useTranslation } from "react-i18next";
import { canv } from "@/canv/global";
import type { VoteWindow } from "../../VoteWindow";
import { NewVoteController } from "../NewVoteController";

function useVotesCount(voteWindow: VoteWindow) {
    return useSyncExternalStore(voteWindow.subscribeVotesCount, voteWindow.getVotesCountSnapshot);
}

export function VotesController() {
    const { t } = useTranslation();
    const votesCount = useVotesCount(canv.appInterface.voteWindow);

    const handleChange = (votes: number) => {
        canv.appInterface.voteWindow.setVotesCount(votesCount + votes);
    };

    const handleInputChange = (votes: number) => {
        canv.appInterface.voteWindow.setVotesCount(votes);
    };

    return (
        <NewVoteController
            name={t("vote.votes")}
            description={t("vote.votesPerParticipant")}
            count={votesCount}
            onChange={handleChange}
            onInputChange={handleInputChange}
        />
    );
}
